import React from "react";

/**
 * Wazco Express brand marks.
 *
 * <LogoMark size={36} />         — just the bird/W icon (square-ish, transparent bg)
 * <LogoWordmark />               — icon + word stacked wordmark
 * <LogoFull className="..." />   — full official logo (icon + typography)
 */
export const LogoMark = React.forwardRef(function LogoMark(
  { size = 36, className = "", rounded = true, glow = true, ...rest },
  ref
) {
  return (
    <span
      ref={ref}
      className={`relative inline-flex items-center justify-center overflow-hidden ${
        rounded ? "rounded-lg" : ""
      } ${className}`}
      style={{ width: size, height: size, background: "linear-gradient(135deg,#0F1130 0%,#1E1150 55%,#0A0F2A 100%)" }}
      {...rest}
    >
      {glow && (
        <span
          aria-hidden
          className="absolute inset-0 opacity-70"
          style={{
            background:
              "radial-gradient(circle at 35% 40%, rgba(94,106,210,0.55), transparent 60%), radial-gradient(circle at 70% 60%, rgba(249,115,22,0.35), transparent 55%)",
          }}
        />
      )}
      <img
        src="/wazco-icon.png"
        alt="Wazco Express"
        draggable="false"
        className="relative z-10 select-none"
        style={{ width: "92%", height: "92%", objectFit: "contain" }}
      />
    </span>
  );
});

export function LogoWordmark({ size = 36, className = "", textClassName = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={size} />
      <div className={textClassName}>
        <div className="font-display font-semibold text-base tracking-tight leading-none">
          <span className="text-[#5E6AD2]">Wazco</span>{" "}
          <span className="text-[#F97316]">Express</span>
        </div>
        <div className="text-[9px] uppercase tracking-[0.22em] text-[#71717A] mt-1">
          Sales · WhatsApp
        </div>
      </div>
    </div>
  );
}

export function LogoFull({ className = "" }) {
  // Dark-theme friendly hero: icon-only PNG (transparent bg) + typographic wordmark below.
  return (
    <div className={`flex flex-col items-center justify-center select-none ${className}`}>
      <img
        src="/wazco-icon.png"
        alt="Wazco Express"
        draggable="false"
        className="w-full max-w-[380px] drop-shadow-[0_18px_55px_rgba(94,106,210,0.45)]"
        style={{ filter: "drop-shadow(0 10px 25px rgba(249,115,22,0.25))" }}
      />
      <div className="mt-6 flex flex-col items-center">
        <div className="font-display font-semibold tracking-tight text-5xl leading-none">
          <span className="text-[#5E6AD2]">Wazco</span>
        </div>
        <div className="font-display font-semibold tracking-[0.3em] text-xs uppercase mt-2 text-[#F97316]">
          Express
        </div>
      </div>
    </div>
  );
}

export default LogoMark;
